import React from "react";

export default ({ text, extraClass }) => (
  <button type="button" className={`button ${extraClass ? extraClass : ""}`}>
    {text}
  </button>
);
